import React, { useState } from "react";
import {
  Sparkles,
  Brush,
  Scissors,
  Droplets,
  Hand,
  PenTool,
  UtensilsCrossed,
  ShoppingBag, // ✅ replaced TakeoutBox
  Music3,
  Dumbbell,
  Dog,
  Car,
  CheckCircle,
} from "lucide-react";

import { Tent } from "lucide-react";
import { categories } from "./category";

const RegisterStep1 = ({ onNext }) => {
  const [selected, setSelected] = useState(null);

  const handleSelect = (label) => {
    setSelected(label);
    setTimeout(() => onNext?.(label), 300);
  };

  return (
    <div className="min-h-screen bg-dry flex flex-col items-center justify-start pt-16 px-5">
      <div
        className="text-center mb-8 bg-drylight w-screen py-16"
        data-aos="fade-up"
      >
        <h2 className="text-3xl md:text-4xl font-medium mb-2 text-text px-3">
          Enjoy your free 30-day trial
        </h2>
        <p className="text-textGray text-sm">
          • No credit card required • No obligations or contracts
        </p>
      </div>

      <h3 className="uppercase text-xs text-text mb-6 tracking-wide">
        What services do you offer?
      </h3>

      <div
        className="grid grid-cols-3 md:grid-cols-6 gap-3 max-w-4xl mx-auto"
        data-aos="fade-up"
      >
        {categories.map((item, idx) => {
          const isSelected = selected === item.label;

          return (
            <div
              key={idx}
              onClick={() => handleSelect(item.label)}
              className={`group flex flex-col items-center justify-center cursor-pointer border rounded-md p-6 transition text-center 
          hover:border-redlight hover:bg-redlightlight
          ${
            isSelected
              ? "border-redlight bg-redlightlight"
              : "border-drylight bg-dry"
          }`}
            >
              <div className="mb-4">{item.icon}</div>

              <div
                className={`flex items-center gap-1 text-sm font-medium transition 
            ${isSelected ? "text-dry" : "text-text group-hover:text-dry"}`}
              >
                {isSelected && <CheckCircle size={16} className="text-dry" />}
                {item.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegisterStep1;
